var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"feature",attrs:{"target":"_blank","href":_vm.item.url}},[_c('div',{staticClass:"feature-title"},[_vm._v(_vm._s(_vm.item.title)),(_vm.item.description)?_c('small',[_vm._v(_vm._s(_vm.item.description))]):_vm._e()]),_c('app-icon',{staticClass:"feature-chevron",attrs:{"icon":"chevron.right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }